exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chioseGoods[data-v-578c4a3e]{border:1px solid #e8e8e8;margin-bottom:10px;padding:10px 10px}.chioseGoodsList[data-v-578c4a3e]{display:inline-block;margin-left:15px;margin-top:10px}", ""]);

// exports
